import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import RoasProduct from '../views/RoasProduct.vue'
import SettingProducts from '../views/SettingProducts.vue'
import Alignment from '../views/Alignment.vue'
import AdCluster from '../views/AdCluster.vue'
import TotallingTargets from '../views/TotallingTargets.vue'
import MallAd from '../views/MallAd.vue'
import PrivateAd from '../views/PrivateAd.vue'
import PrivateAdStatus from '../views/PrivateAdStatus.vue'
import AdMediaApi from '../views/AdMediaApi.vue'
import UpdateConfig from '../views/UpdateConfig.vue'
import SettingDelivery from '../views/SettingDelivery.vue'
import SettingService from '../views/SettingService.vue'
import SettingTempoCode from '../views/SettingTempoCode.vue'
import store from '../store';
import AdAccount from '../views/AdAccount.vue'
import SetMedia from '../views/MediaSetting.vue'
import ProductMaster from '../views/ProductMaster.vue'
import TempoSales from '../views/TempoSales.vue'
import ZozoSales from '../views/ZozoSales.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        // redirect: '/'
    },
    {
        path: '/roas_product',
        name: 'RoasProduct',
        component: RoasProduct
    },
    {
        path: '/product_ad_register',
        name: 'SettingProducts',
        component: SettingProducts
    },
    {
        path: '/alignment',
        name: 'Alignment',
        component: Alignment
    },
    {
        path: '/ad_cluster',
        name: 'AdCluster',
        component: AdCluster
    },
    {
        path: '/totalling_targets',
        name: 'TotallingTargets',
        component: TotallingTargets
    },
    {
        path: '/mall_ad',
        name: 'MallAd',
        component: MallAd
    },
    {
        path: '/private_ad',
        name: 'PrivateAd',
        component: PrivateAd
    },
    {
        path: '/private_ad_status',
        name: 'PrivateAdStatus',
        component: PrivateAdStatus
    },
    {
        path: '/ad_media_api',
        name: 'AdMediaApi',
        component: AdMediaApi
    },
    {
        path: '/config',
        name: 'Config',
        component: UpdateConfig
    },
    {
        path: '/delivery',
        name: 'Delivery',
        component: SettingDelivery
    },
    {
        path: '/service',
        name: 'Service',
        component: SettingService
    },
    {
        path: '/tempo_code',
        name: 'TempoCode',
        component: SettingTempoCode
    },
    {
        path: '*',
        redirect:  '/'
    },
    {
        path:'/ad_account',
        name: 'AdAccount',
        component: AdAccount
    },
    {
        path:'/set_media',
        name: 'SetMedia',
        component: SetMedia
    },
    {
        path: '/product_master',
        name: 'ProductMaster',
        component: ProductMaster
    },
    {
        path: '/tempo_sales',
        name: 'TempoSales',
        component: TempoSales
    },
    {
        path: '/zozo_sales',
        name: 'ZozoSales',
        component: ZozoSales
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name == 'Login' && store.state.isAuth) {
        next(from.name ? false : { name: 'Home' })
        return
    }
    if (to.name != 'Login' && !store.state.isAuth) {
        next({ name: 'Login' })
        return
    }
    next()
})

export default router
